import { render, staticRenderFns } from "./advancesItem.vue?vue&type=template&id=16054714&scoped=true"
import script from "./advancesItem.vue?vue&type=script&lang=js"
export * from "./advancesItem.vue?vue&type=script&lang=js"
import style0 from "./advancesItem.vue?vue&type=style&index=0&id=16054714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16054714",
  null
  
)

export default component.exports